"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatedDataSessionEvent = exports.ErrorRefreshingSessionEvent = exports.RefreshedSessionEvent = exports.RefreshingSessionEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class RefreshingSessionEvent extends web_ui_framework_1.Event {
}
exports.RefreshingSessionEvent = RefreshingSessionEvent;
class RefreshedSessionEvent extends web_ui_framework_1.Event {
}
exports.RefreshedSessionEvent = RefreshedSessionEvent;
class ErrorRefreshingSessionEvent extends web_ui_framework_1.Event {
}
exports.ErrorRefreshingSessionEvent = ErrorRefreshingSessionEvent;
class UpdatedDataSessionEvent extends web_ui_framework_1.Event {
}
exports.UpdatedDataSessionEvent = UpdatedDataSessionEvent;
//# sourceMappingURL=sessionEvents.js.map